import { Navigate, RouteObject } from "react-router";
import GfsOverviewRoute from "@/routes/processes/[processId]/gfs/overview/overview";
import GfsAssessmentsRoute from "@/routes/processes/[processId]/gfs/assessments/assessments-route";
import GfsAssessmentRoute from "@/routes/processes/[processId]/gfs/assessments/[assessmentId]/assessment-route";
import GfsAssessmentAreasRoute from "@/routes/processes/[processId]/gfs/assessments/[assessmentId]/index-route";
import GfsAssessmentAdditionalInfoRoute from "@/routes/processes/[processId]/gfs/assessments/[assessmentId]/additional-info/additional-info-route";
import GfsAssessmentOverviewRoute from "@/routes/processes/[processId]/gfs/assessments/[assessmentId]/overview/overview-route";
import GfsCalculationsRoute from "@/routes/processes/[processId]/gfs/calculations/calculations-route";
import GfsCalculationsIndexRoute from "@/routes/processes/[processId]/gfs/calculations/index-route";
import GfsCalculationRoute from "@/routes/processes/[processId]/gfs/calculations/[calculationId]/calculation-route";
import GfsOffersRoute from "@/routes/processes/[processId]/gfs/offers/offers-route";
import GfsOffersIndexRoute from "@/routes/processes/[processId]/gfs/offers/index-route";
import GfsOfferRoute from "@/routes/processes/[processId]/gfs/offers/[offerId]/offer-route";
import GfsOfferIndexRoute from "@/routes/processes/[processId]/gfs/offers/[offerId]/index-route";
import GfsOfferOverviewRoute from "@/routes/processes/[processId]/gfs/offers/[offerId]/overview/overview-route";
import GfsOfferCalculationRoute from "@/routes/processes/[processId]/gfs/offers/[offerId]/calculation/calculation-route";
import GfsOfferObjectRoute from "@/routes/processes/[processId]/gfs/offers/[offerId]/object/object-route";
import GfsOfferContactRoute from "@/routes/processes/[processId]/gfs/offers/[offerId]/contact/contact-route";
import GfsOfferCoverLetterRoute from "@/routes/processes/[processId]/gfs/offers/[offerId]/coverletter/coverletter-route";
import GfsOfferDocumentRoute from "@/routes/processes/[processId]/gfs/offers/[offerId]/offer-document/offer-document-route";
import GfsOfferPestsRoute from "@/routes/processes/[processId]/gfs/offers/[offerId]/pests/pests-route";

export const gfsRoutes: RouteObject[] = [
  { index: true, element: <Navigate to="overview" replace /> },
  { path: "overview", element: <GfsOverviewRoute /> },
  {
    path: "assessments",
    element: <GfsAssessmentsRoute />,
  },
  {
    path: "assessments/:assessmentId",
    element: <GfsAssessmentRoute />,
    children: [
      {
        index: true,
        element: <GfsAssessmentAreasRoute />,
      },
      {
        path: "additional-info",
        element: <GfsAssessmentAdditionalInfoRoute />,
      },
      {
        path: "overview",
        element: <GfsAssessmentOverviewRoute />,
      },
    ],
  },
  {
    path: "calculations",
    element: <GfsCalculationsRoute />,
    children: [
      {
        index: true,
        element: <GfsCalculationsIndexRoute />,
      },
      {
        path: ":calculationId",
        element: <GfsCalculationRoute />,
      },
    ],
  },
  {
    path: "offers",
    element: <GfsOffersRoute />,
    children: [
      {
        index: true,
        element: <GfsOffersIndexRoute />,
      },
      {
        path: ":offerId",
        element: <GfsOfferRoute />,
        children: [
          {
            path: "offertext",
            element: <GfsOfferDocumentRoute />,
          },
          {
            index: true,
            element: <GfsOfferIndexRoute />,
          },
          {
            path: "overview",
            element: <GfsOfferOverviewRoute />,
          },
          {
            path: "calculation",
            element: <GfsOfferCalculationRoute />,
          },
          {
            path: "object",
            element: <GfsOfferObjectRoute />,
          },
          { path: "addresses", element: <Navigate to="../contact" replace /> },
          {
            path: "contact",
            element: <GfsOfferContactRoute />,
          },
          {
            path: "pests",
            element: <GfsOfferPestsRoute />,
          },
          {
            path: "coverletter",
            element: <GfsOfferCoverLetterRoute />,
          },
        ],
      },
    ],
  },
];
